//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {CollapseTransition} from "@ivanv/vue-collapse-transition";

export default {
  components: {
    CollapseTransition,
  },
  props: {
    listTranslationsKey: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true,
      validator: function (value) {
        return value.length > 0 && !value.find((item) => {return !item.hasOwnProperty('id')});
      }
    },
  },
  data() {
    return {
      activeItem: null,
      scrollTimeout: null,
    }
  },
  created() {
    this.items.forEach((el, key) => {
      this.$set(el, 'sort', key);
      this.$set(el, 'isActive', false);
    });
  },
  mounted() {
  },
  methods: {
    activateItem(item) {
      clearTimeout(this.scrollTimeout);
      if (this.activeItem) {
        this.activeItem.isActive = false;

        if (this.activeItem.id === item.id) {

          if (this.$refs.hasOwnProperty('listMainContainer')) {
            const ref = this.$refs['listMainContainer'];
            this.$nextTick(() => {
              this.scrollTimeout = setTimeout(() => {
                this.$store.dispatch('scrollToElement', {
                  element: ref,
                  duration: 600
                });
              }, 600);
            });
          }

          this.activeItem = null;
          return;
        }
      }
      this.activeItem = item;
      item.isActive = true;

      if (this.$refs.hasOwnProperty(`listItem${item.id}`)) {
        const ref = this.$refs[`listItem${item.id}`][0];
        this.$nextTick(() => {
          this.scrollTimeout = setTimeout(() => {
            this.$store.dispatch('scrollToElement', {
              element: ref,
              duration: 600
            });
          }, 600);
        });
      }
    }
  }
};
